import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface GetBranchResponse {
    customer_idx: number;
    customer_name: string;
    branch: { branch_idx: number; branch_option: string }[];
}

export const useGetOrderBranch = (
    searchtxt?: string,
    customerIdx?: number | null,
    special?: boolean,
): UseQueryResult<GetBranchResponse[], Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetBranchResponse[], Error>({
        queryKey: ["getOrderBranch", searchtxt, customerIdx, special],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_order_branch}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    search: "customer_name",
                    searchtxt,
                    special: searchtxt ? {} : special,
                    customer_idx: searchtxt ? {} : special ? {} : customerIdx,
                },
            });
            return response.data.data;
        },
    });
};
